// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2Rv83","footer":"ModalUpdate_footer__H4ryX"};